import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./theme.scss";
import "./App.scss"
import axios from "axios";
import qs from "qs";
import { useHistory, useLocation } from 'react-router-dom';
import FooterLinks from "./SharedModules/Layout/FooterLinks";
import LoginPage  from './Modules/UserLogin/LoginPage'
import OTPPage from './Modules/UserLogin/OTPPage'
import NewLogin from "./Modules/UserLogin/NewLogin";
import {
  requiresOtpFromLoginResponse,
  isV2LoginPasswordExpired,
  isV2LoginPasswordExpiryWarning,
  extractUserIdFromLoginResponse,
  isV2LoginNoMfa,
  isV2LoginSuccessful,
  extractOtpAuthId,
  isOtpValidateSuccess,
} from './SharedModules/utility/otpConfig';
import Spinner from './SharedModules/Spinner/Spinner';
import ManageUser from "./Modules/Manage_User";
import Header from "./Modules/Header";
import { getMyAccDetailsAction, setForcePasswordChange } from './Modules/UserSearch/action';
import { MY_ACCOUNT, USER_SEARCH, MANAGE_ACCOUNT_ADDEDIT, PROVIDER_PORTAL_LP  } from "./SharedModules/Navigation/RouteConstants";
import { CMdSPortals, ERR_PROCESSING_REQ, X_CMDS_APP_CODE, SELECT_ORG, CMDS_LAST_ACTIVITY_TS, CMDS_SESSION_TIMEOUT_MINUTES, GLOBAL_SESSION_TIMEOUT_MESSAGE, GLOBAL_SESSION_TIMEOUT_WARNING_MESSAGE, GLOBAL_SESSION_TIMEOUT_WARNING_DISMISSED, GLOBAL_SESSION_TIMEOUT_STAY_SIGNED_IN, USER_REQUESTED_LOGOUT, CMDS_SESSION_IFRAME_ID, SESSION_EXPIRY_MSG } from "./SharedModules/AppConstants";
import * as ErrorMsgConstants from "./SharedModules/Messages/ErrorMsgConstants";
import {safeLocalStorage, navigateToCMdSApp} from './SharedModules/utility/utilityFunction';
import * as TextConst from "./Modules/UserSearch/ManageAccountConstants";
import ChangePassword from './Modules/UserLogin/ChangePassword';
import * as serviceEndPoint from './SharedModules/services/service';
import moment from 'moment';
import { momentFromUnknown } from './SharedModules/DateUtilities/DateUtilities';
import { getStateImplCode } from "./SharedModules/Dropdowns/actions";
import { Button } from 'react-bootstrap';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

function getBrowserTimeZone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (e) {
    return undefined;
  }
}
/** Short zone abbreviation only (optional placeholder `tz` in REACT_APP_DOWNTIME_MESSAGE). */
function getLocalTimeZoneAbbreviation(date) {
  const timeZone = getBrowserTimeZone();
  const opts = { timeZoneName: 'short' };
  if (timeZone) opts.timeZone = timeZone;
  try {
    const parts = new Intl.DateTimeFormat('en-US', opts).formatToParts(date);
    const tzPart = parts.find((p) => p.type === 'timeZoneName');
    return tzPart ? tzPart.value : '';
  } catch (e) {
    return '';
  }
}
/** Local date + time + short zone (e.g. EST); no seconds; TZ always appended when available. */
function formatDowntimeInstant(date) {
  const timeZone = getBrowserTimeZone();
  const tzOpt = timeZone ? { timeZone } : {};
  try {
    const datePart = new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      ...tzOpt,
    }).format(date);
    const timePart = new Intl.DateTimeFormat('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      ...tzOpt,
    }).format(date);
    const abbr = getLocalTimeZoneAbbreviation(date);
    const base = `${datePart}, ${timePart}`;
    return abbr ? `${base} ${abbr}` : base;
  } catch (e) {
    const abbr = getLocalTimeZoneAbbreviation(date);
    const dtOnly = new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      ...tzOpt,
    }).format(date);
    return abbr ? `${dtOnly} ${abbr}` : dtOnly;
  }
}

const HomePage = (props) => {  
  const dispatch = useDispatch();
  const params = new URLSearchParams(window.location.search);
  const code = params.get("code");
  const uid = params.get("uid");
  const fromOrg = params.get("fromOrg");
  const scode = localStorage.getItem("code");
  const checked = localStorage.getItem("Checked");
  const [user, setUser] = React.useState("");
  const [isPassword, setIsPassword] = React.useState(false);
  const [loginState, setLoginState] = React.useState(false);
  const [isLogin, setIsLogin] = React.useState(!!(uid || code || scode));
  const [appList, setAppList] = React.useState([]);
  const [downtime, setDownTime] = React.useState(false);
  const [upComingDowntime, setUpComingDownTime] = React.useState(false);
  const [donwTimeMsg, setDownTimeMsg] = React.useState('');
  const getDetails = id => dispatch(getMyAccDetailsAction(id));
  const userDetailsData = useSelector(state => state.userManagement?.myAccDetailsResponse);
  const history1 = useHistory();
  const location = useLocation();
  const [footerLinks, setFooterLinks] = React.useState(false);
  const [footerLinksName, setFooterLinksName] = React.useState("");

  const [spinnerLoader, setspinnerLoader] = React.useState(false);
  const [warningMessages, setWarningMessages] = React.useState([]);
  const [infoMessages, setInfoMessages] = React.useState([]);
  const [errorMessages, setErrorMessages] = React.useState([]);
  const [successMessages, setSuccessMessages] = React.useState([]);
  const [logInType, setLoginType] = React.useState(null);
  const [isOtpFlow, setIsOtpFlow] = React.useState(false);
  const [otpAuthId, setOtpAuthId] = React.useState(null);
  const [isV2PasswordExpiredFlow, setIsV2PasswordExpiredFlow] = React.useState(false);
  const [showSessionTimeoutPopup, setShowSessionTimeoutPopup] = React.useState(false);
   const [resendOtpDisabled, setResendOtpDisabled] = React.useState(false);

  const hasLoggedOut = useRef(false);
  /** Password expiry warning (statusCode 1) — show on portals after OTP, not on OTP screen. */
  const passwordExpiryPortalMessageRef = useRef(null);
  const sessionTimeoutIframeRef = useRef(null);
  const lastPostToPortalsTime = useRef(0);
  const savedTabTitleRef = useRef(null);
  const footerLegalSavedTitleRef = useRef(null);
  const SESSION_TIMEOUT_TAB_TITLE = 'Session Expiring - Action Required';
  React.useEffect(() => {
    if (showSessionTimeoutPopup) {
      if (!savedTabTitleRef.current) savedTabTitleRef.current = document.title;
      document.title = SESSION_TIMEOUT_TAB_TITLE;
    } else {
      if (savedTabTitleRef.current) {
        document.title = savedTabTitleRef.current;
        savedTabTitleRef.current = null;
      }
    }
  }, [showSessionTimeoutPopup]);

  const LEGAL_PAGE_TAB_TITLES = {
    PrivacyPolicy: 'Privacy Policy',
    TermsofUse: 'Terms of Use',
    BrowserRequirements: 'Browser Requirements',
    AccessibilityCompliance: 'Accessibility Compliance',
  };
  React.useEffect(() => {
    if (footerLinks && footerLinksName && LEGAL_PAGE_TAB_TITLES[footerLinksName]) {
      if (footerLegalSavedTitleRef.current === null) {
        footerLegalSavedTitleRef.current = document.title;
      }
      document.title = LEGAL_PAGE_TAB_TITLES[footerLinksName];
      return;
    }
    if (!footerLinks && footerLegalSavedTitleRef.current !== null) {
      document.title = footerLegalSavedTitleRef.current;
      footerLegalSavedTitleRef.current = null;
    }
  }, [footerLinks, footerLinksName]);
  const [showLink,setShowLink] = useState(["MyAcc"]);
  const defaultFormValue = {
    oldPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  };
  const [formValue, setformValue] = React.useState(defaultFormValue);
  const [changeState, setChangeState] = React.useState(false);
  const [successData, setSuccessData] = React.useState('');
  const [values, setValues] = React.useState({
    username: '',
    password: '',
    showPassword: false,
    count: 0,
    void: false,
    accessBox: false,
    linksBox: true,
    updatesBox: true,
  });
  const [
      {
        invalidUsrPassErr
      },
      setShowErrors,
    ] = React.useState(false);
  const redirectToLandingPage = () => {
    setLoginState(false);
    setIsLogin(false);
    setIsV2PasswordExpiredFlow(false);
    setIsPassword(false);
    setInfoMessages([]);
    setWarningMessages([]);
    setErrorMessages([]);
    logOut();
    setChangeState(false);
    setValues({
      username: "",
      password: "",
      voiChk: false,
    });
  };
 
  const tokenInterval = () => {
    let expTime= localStorage.getItem('expiresInSeconds');
    if(tokenIntervalID){
      clearTimeout(tokenIntervalID)
    }
    if(expTime){
    tokenIntervalID = setTimeout(() => {
      refreshToken(
        localStorage.getItem("refreshToken"),
        localStorage.getItem("username")
      );
    }, expTime* 1000 - 10000);
  }
  };
  const getDownTime = () => {
    const applyDowntimeWindow = (sdt, edt) => {
      const dt = new Date();
      const ndt = new Date(sdt);
      ndt.setDate(sdt.getDate() - (+process.env.REACT_APP_DOWNTIME_NOTIFY_DAYS));
      setDownTime(new Date(edt) > dt && dt > new Date(sdt));
      setUpComingDownTime(ndt < dt && dt < new Date(edt));
      const template = process.env.REACT_APP_DOWNTIME_MESSAGE || '';
      const msg = template
        .replace('sdt', formatDowntimeInstant(sdt))
        .replace('edt', formatDowntimeInstant(edt));
      setDownTimeMsg(msg);
    };

    var config = {
      method: "get",
      url: process.env.REACT_APP_DOWNTIME,
      headers: {
        'X-CMDS-APP-CODE' : X_CMDS_APP_CODE,
        Authorization: localStorage.getItem("accessToken"),
        Username: localStorage.getItem("username"),
      },
    };
    axios(config)
      .then(function (response) {
        let sdt, edt, duration, durationH, durationM;
        if(response?.data?.startDateTime){
          duration = response.data?.duration;
          if(duration){
            durationH = +duration.split(':')[0];
            durationM = +duration.split(':')[1];
          }
          sdt = new Date(response.data?.startDateTime);
          edt = new Date(sdt);
          edt.setHours(edt.getHours() + durationH);
          edt.setMinutes(edt.getMinutes() + durationM);
          edt = new Date(edt);
          applyDowntimeWindow(sdt, edt);
        }
      })
      .catch(function (error) {
        console.log("error=>",error,error?.data,error?.status);
      });
  };
 
  const storeCred = (a, r, u, e, s, isRefresh) => {
    clearInterval(tokenIntervalID);
    postToCMDSPortals({
      accessToken: a,
      refreshToken: r,
      username: u,
      expiresInSeconds: e,
      ssoToken: s,
    });
    document.cookie = `${process.env.REACT_APP_COOKIE_NAME}=${s}; Domain=${process.env.REACT_APP_DOMAIN_NAME}; Path=/;`;
    localStorage.setItem("accessToken", a);
    localStorage.setItem("refreshToken", r);
    localStorage.setItem("username", u);
    localStorage.setItem("expiresInSeconds", e);
    tokenInterval();
    if(!isRefresh){
      getDownTime()
    }
  };
  const storeAppInfo = (l = []) => {
    localStorage.setItem("applist", JSON.stringify(l));
  };
 
  const parseJwt = (token) => {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    return JSON.parse(jsonPayload);
  };
 
  const clearLoginMessages = () => {
    setInfoMessages([]);
    setWarningMessages([]);
    setSuccessMessages([]);
    setErrorMessages([]);
  };

  const isLoginResponseFailure = (res) =>
    res?.data?.successful === false || res?.data?.success === false;

  const handleLoginFailure = (res) => {
    setspinnerLoader(false);
    window.localStorage.clear();
    window.sessionStorage.clear();
    if (isLoginResponseFailure(res) &&
      (res.data?.message === ErrorMsgConstants.LOGIN_FAILURE
        || res.data?.message === ErrorMsgConstants.AFTER_ONE_MORE_ATTEMPT
        || res.data?.message === ErrorMsgConstants.AFTER_TWO_MORE_ATTEMPT
        || res.data?.message === ErrorMsgConstants.NO_SPECIAL_CHAR_UN_PWD
        || res.data?.message === ErrorMsgConstants.AUTHENTICATION_FAILED
        || res.data?.message === ErrorMsgConstants.CREDENTIAL_NVALID
        || res.data?.statusCode === '-1')) {
      setShowErrors({ invalidUsrPassErr: true });
      clearLoginMessages();
      setErrorMessages([ErrorMsgConstants.INVALID_CREDENTIALS]);
      if (isOtpFlow) {
        setLoginType(TextConst.NORMAL_LOGIN);
        setOtpAuthId(null);
        setIsOtpFlow(false);
      }
    }
    if (isLoginResponseFailure(res) &&
      res.data?.errorMessage === ErrorMsgConstants.ACC_INACTIVE) {
      clearLoginMessages();
      setErrorMessages([ErrorMsgConstants.ACCOUNT_DEACTIVATED]);
    }
    if (isLoginResponseFailure(res) && (res.data?.message === ErrorMsgConstants.USER_LOCKED
      || res.data?.message === ErrorMsgConstants.ACC_LOCKED
      || res.data?.message === ErrorMsgConstants.GRACE_LOGIN_EXHAUSTED)) {
      clearLoginMessages();
      setErrorMessages([ErrorMsgConstants.ACCOUNT_LOCKED]);
    }
    if (isLoginResponseFailure(res) && res.data?.message === ErrorMsgConstants.PASSWORD_EXPIRED_ERR_TYPE
      || res.data?.errorMessage === ErrorMsgConstants.ACCOUNT_PWD_EXP) {
      setLoginType('');
      setIsPassword(true);
      clearLoginMessages();
      setErrorMessages([ErrorMsgConstants.PASSWORD_EXPIRED]);
    }
    if (isLoginResponseFailure(res) && res.data?.errorType === ErrorMsgConstants.UNAUTHORIZED && res.data?.errorMessage === ErrorMsgConstants.ACC_INACTIVE) {
      clearLoginMessages();
      setErrorMessages([ErrorMsgConstants.DEACTIVATED]);
    }
  };

  const applyPasswordExpiryWarningIfNeeded = (d) => {
    const expiryM = d?.passwordExpiry
      ? momentFromUnknown(d.passwordExpiry)
      : null;
    const diff =
      expiryM && expiryM.isValid()
        ? expiryM.diff(moment(), 'days')
        : 90;
    if (
      diff <= process.env.REACT_APP_PASSWORD_EXPIRY_DAYS
      && !d?.forcePasswordChange
    ) {
      setWarningMessages([
        `Password is about to expire in ${diff} days.`,
      ]);
    }
  };

  const handleLoginSuccess = (res) => {
    const portalPasswordExpiryMsg = passwordExpiryPortalMessageRef.current;
    passwordExpiryPortalMessageRef.current = null;
    setSuccessMessages([]);
    setErrorMessages([]);
    if (portalPasswordExpiryMsg) {
      setInfoMessages([portalPasswordExpiryMsg]);
    } else {
      setInfoMessages([]);
    }
    let d = parseJwt(res.data?.data);
    localStorage.setItem('accessToken', res.data.accessToken);
    localStorage.setItem('refreshToken', res.data.refreshToken);
    localStorage.setItem('username', d?.username);
    localStorage.setItem("user", `${d.lastname}, ${d.firstname}`);
    localStorage.setItem("orgList", JSON.stringify(d?.orglist));
    localStorage.setItem("initLogin", "true");
    localStorage.setItem("logInType", 'NORMAL_LOGIN');
    setSuccessData(d);
    storeAppInfo(d?.applist || []);
    setAppList(d?.applist || []);
    dispatch(getStateImplCode());
    setLoginState(true);
    safeLocalStorage(
      'set',
      'loginState',
      JSON.stringify({
        loginUserName: d?.username,
        loginUserId: d?.userId,
        userPrivileges: d?.roles?.split(',') || [],
        time: Date.now(),
        applist: d?.applist,
        passwordExpiry: d?.passwordExpiry,
        firstName: d?.firstname,
        lastName: d?.lastname,
        forcePasswordChange: d?.forcePasswordChange,
        locked: d?.locked,
        email: d?.email,
        accessToken: d?.accessToken,
        refreshToken: d?.refreshToken,
        orgId: d?.organization,
        orglist: d?.orglist,
        userType: d?.userType,
        clientMappingKey: d?.clientMappingKey
      })
    );
    storeCred(
      res.data?.accessToken,
      res.data?.refreshToken,
      d?.username,
      res.data?.expiresInSeconds,
      res.data?.ssoToken || localStorage.getItem('ssoToken')
    );
    localStorage.setItem('isNormalUser', 'true');
    setLoginType('');
    setIsOtpFlow(false);
    setOtpAuthId(null);

    if (
      process.env.REACT_APP_LOGIN_THROUGH === TextConst.PRODUCT
      && d?.forcePasswordChange
    ) {
      setIsLogin(false);
      dispatch(setForcePasswordChange(true));
      setIsPassword(true);
      setspinnerLoader(false);
      setWarningMessages([ErrorMsgConstants.FIRST_TIME_LOGIN]);
      return;
    }

    setUser(`${d.lastname}, ${d.firstname}`);
    setIsLogin(true);
    setspinnerLoader(false);
    applyPasswordExpiryWarningIfNeeded(d);
  };

  const isLoginResponseSuccess = (res) =>
    res?.data?.successful === true || res?.data?.success === true;

  const handleLoginResponse = (res) => {
    if (isLoginResponseSuccess(res)) {
      handleLoginSuccess(res);
    } else {
      handleLoginFailure(res);
    }
  };

  const getLoginPayload = () => ({
    password: changeState ? formValue.newPassword : values.password,
    username: values.username.toUpperCase(),
  });

  const requestValidateOtp = (authId, otp) =>
    axios.post(`${serviceEndPoint.V2_VALIDATE_OTP_ENDPOINT}`, {
      authId: authId,
      userId: values.username.toUpperCase(),
      oneTimePasscode: otp.trim(),
    });

  const handleAuthChainError = (res) => {
    setspinnerLoader(false);
    setErrorMessages([ ErrorMsgConstants.ERROR_OCCURED_DURING_TRANSACTION,
    ]);
  };

  const proceedToNoMfaLogin = (loginRes) => {
    if (!loginRes?.data?.accessToken) {
      handleAuthChainError(loginRes);
      return;
    }
    handleLoginSuccess(loginRes);
  };

  const proceedToPasswordExpired = (loginRes) => {
    setspinnerLoader(false);
    setIsOtpFlow(false);
    setOtpAuthId(null);
    setLoginType('');
    setIsV2PasswordExpiredFlow(true);
    setIsPassword(true);
    clearLoginMessages();
    setErrorMessages([
      ErrorMsgConstants.PASSWORD_EXPIRED,
    ]);
  };

  const handleV2PasswordChangedReLogin = () => {
    setIsV2PasswordExpiredFlow(false);
    setIsPassword(false);
    setformValue(defaultFormValue);
    setChangeState(false);
    logOut();
  };

  const requestIgnorePasswordExpiry = (loginAuthId, userId) =>
    axios.post(serviceEndPoint.V2_IGNORE_PASSWORD_ENDPOINT, {
      authId: loginAuthId,
      userId,
    });

  const showOtpScreen = ({ authId, infoMessages = [], successMessages = [] }) => {
    setspinnerLoader(false);
    setIsOtpFlow(true);
    setOtpAuthId(authId);
    setResendOtpDisabled(false);
    setLoginType(TextConst.OTP_LOGIN);
    clearLoginMessages();
    if (infoMessages.length) {
      setInfoMessages(infoMessages);
    }
    if (successMessages.length) {
      setSuccessMessages(successMessages);
    }
  };

  const proceedToPasswordExpiryWarningOtp = (loginRes) => {
    const loginAuthId = extractOtpAuthId(loginRes);
    const userId =
      extractUserIdFromLoginResponse(loginRes) || values.username.toUpperCase();
    if (!loginAuthId || !userId) {
      setspinnerLoader(false);
      setErrorMessages([ErrorMsgConstants.ERROR_OCCURED_DURING_TRANSACTION]);
      return;
    }
    requestIgnorePasswordExpiry(loginAuthId, userId)
      .then(ignoreRes => {
        if (!(isV2LoginSuccessful(ignoreRes) || isLoginResponseSuccess(ignoreRes))) {
          handleAuthChainError(ignoreRes);
          return;
        }
        const otpAuthIdAfterIgnore = extractOtpAuthId(ignoreRes) ?? loginAuthId;
        showOtpScreen({
          authId: otpAuthIdAfterIgnore,
          successMessages: [
            'OTP has been sent to your registered email address.',
          ],
        });
      })
      .catch(err => {
        if (err?.response) {
          handleAuthChainError(err.response);
          return;
        }
        setspinnerLoader(false);
        setErrorMessages([ErrorMsgConstants.ERROR_OCCURED_DURING_TRANSACTION]);
      });
  };

  const proceedToOtpFlow = (loginRes) => {
    const authId = extractOtpAuthId(loginRes);
    if (!authId) {
      setspinnerLoader(false);
      setErrorMessages([ErrorMsgConstants.ERROR_OCCURED_DURING_TRANSACTION]);
      return;
    }
    showOtpScreen({
      authId,
      successMessages: [
        'OTP has been sent to your registered email address.',
      ],
    });
  };

  const handleLoginResponseWithMfa = (res) => {
    if (!isV2LoginSuccessful(res)) {
      handleLoginFailure(res);
      return;
    }
    if (isV2LoginPasswordExpired(res)) {
      proceedToPasswordExpired(res);
      return;
    }
    if (isV2LoginPasswordExpiryWarning(res)) {
      proceedToPasswordExpiryWarningOtp(res);
      return;
    }
    if (requiresOtpFromLoginResponse(res)) {
      proceedToOtpFlow(res);
      return;
    }
    if (isV2LoginNoMfa(res)) {
      proceedToNoMfaLogin(res);
      return;
    }
    setspinnerLoader(false);
    setErrorMessages([ErrorMsgConstants.ERROR_OCCURED_DURING_TRANSACTION]);
  };

  const submitSuccess = () => {
    clearLoginMessages();
    setspinnerLoader(true);
    axios.post(`${serviceEndPoint.V2_USER_LOGIN_ENDPOINT}`, getLoginPayload())
      .then(handleLoginResponseWithMfa)
      .catch(() => {
        setspinnerLoader(false);
        setErrorMessages([ErrorMsgConstants.ERROR_OCCURED_DURING_TRANSACTION]);
      });
  };

  const onNormalLoginSelect = () => {
    passwordExpiryPortalMessageRef.current = null;
    clearLoginMessages();
    setOtpAuthId(null);
    setIsOtpFlow(false);
    setLoginType(TextConst.NORMAL_LOGIN);
  };

  const handleLogonSubmit = () => {
    submitSuccess();
  };

  const resetOtpSession = React.useCallback(() => {
    passwordExpiryPortalMessageRef.current = null;
    setOtpAuthId(null);
    setIsOtpFlow(false);
    setLoginType(TextConst.NORMAL_LOGIN);
    setResendOtpDisabled(false);
    setWarningMessages([]);
    setSuccessMessages([]);
    setErrorMessages([]);
  }, []);

  const handleOtpSessionExpire = React.useCallback(() => {
    resetOtpSession();
  }, [resetOtpSession]);

  const getResendOtpCode = (data) =>
    `${data?.code || ''} ${data?.reason || ''} ${data?.errorType || ''}`;

  const getResendOtpMessage = (data) => data?.message || data?.errorMessage || '';

  const isResendOtpUnauthorized = (data) =>
    !!data
    && (data.success === false
      || /unauthorized|login\s*failure/i.test(data.errorType || '')
      || /unauthorized|login\s*failure/i.test(data.errorMessage || ''));

  const handleResendOtp = React.useCallback(() => {
    if (resendOtpDisabled) return;
    setWarningMessages([]);
    setErrorMessages([]);
    setSuccessMessages([]);
    if (!otpAuthId) {
      setErrorMessages([ErrorMsgConstants.ERROR_OCCURED_DURING_TRANSACTION]);
      return;
    }
    setspinnerLoader(true);
    axios.post(`${serviceEndPoint.V2_RESEND_OTP_ENDPOINT}`, {
      authId: otpAuthId,
      userId: values.username.toUpperCase(),
    })
      .then(res => {
        setspinnerLoader(false);
        const data = res?.data ?? {};
        if (isResendOtpUnauthorized(data)) {
          setResendOtpDisabled(true);
          setErrorMessages([
            getResendOtpMessage(data) || ErrorMsgConstants.ERROR_OCCURED_DURING_TRANSACTION,
          ]);
          return;
        }
        const newAuthId = extractOtpAuthId(res);
        if (newAuthId) {
          setOtpAuthId(newAuthId);
        }
        setSuccessMessages([
          'OTP has been resent to your registered email address.',
        ]);
      })
      .catch(err => {
        setspinnerLoader(false);
        const errData = err?.response?.data;
        if (isResendOtpUnauthorized(errData) || err?.response?.status === 401) {
          setResendOtpDisabled(true);
          setErrorMessages([
            getResendOtpMessage(errData) || ErrorMsgConstants.ERROR_OCCURED_DURING_TRANSACTION,
          ]);
          return;
        }
        setErrorMessages([ErrorMsgConstants.ERROR_OCCURED_DURING_TRANSACTION]);
      });
  }, [otpAuthId, values.username, resendOtpDisabled]);

  const getValidateOtpCode = (data) =>
    `${data?.code || ''} ${data?.reason || ''} ${data?.errorType || ''}`;

  const getValidateOtpMessage = (data) => data?.message || data?.errorMessage || '';

  const isValidateOtpInvalid = (data) =>
    !!data
    && (/invalid[-\s]?otp/i.test(getValidateOtpCode(data))
      || /verification code is invalid/i.test(getValidateOtpMessage(data)));

  const isValidateOtpUserLocked = (data) =>
    !!data
    && !isValidateOtpInvalid(data)
    && (/locked/i.test(getValidateOtpMessage(data))
      || (/unauthorized/i.test(getValidateOtpCode(data))
        && data.success === false));

  const handleValidateOtpFailure = (data) => {
    setspinnerLoader(false);
    if (isValidateOtpUserLocked(data)) {
      logOut();
      return;
    }
    if (isValidateOtpInvalid(data)) {
      setSuccessMessages([]);
      setInfoMessages([]);
      setErrorMessages([
        ErrorMsgConstants.INVALID_OTP_ERR,
      ]);
      return;
    }
    setErrorMessages([
      ErrorMsgConstants.ERROR_OCCURED_DURING_TRANSACTION,
    ]);
  };

  const verifyOtpAndCompleteLogin = (otp) => {
    if (!otp?.trim()) {
      setSuccessMessages([]);
      setErrorMessages([ErrorMsgConstants.OTP_REQ_ERR]);
      return;
    }
    if (!otpAuthId) {
      setErrorMessages([ErrorMsgConstants.ERROR_OCCURED_DURING_TRANSACTION]);
      return;
    }
    clearLoginMessages();
    setspinnerLoader(true);
    requestValidateOtp(otpAuthId, otp)
      .then(otpRes => {
        const data = otpRes?.data ?? {};
        if (!isOtpValidateSuccess(otpRes)) {
          handleValidateOtpFailure(data);
          return;
        }
        if (!data.accessToken) {
          handleAuthChainError(otpRes);
          return;
        }
        if (data.ssoToken) {
          localStorage.setItem('ssoToken', data.ssoToken);
        }
        handleLoginSuccess(otpRes);
      })
      .catch(err => {
        const errData = err?.response?.data;
        if (errData) {
          handleValidateOtpFailure(errData);
          return;
        }
        setspinnerLoader(false);
        setErrorMessages([ErrorMsgConstants.ERROR_OCCURED_DURING_TRANSACTION]);
      });
  };
 
  let userData = JSON.parse(localStorage.getItem("loginState"));
  let tokenIntervalID = null;
 
  const getLWN = () => {
    return JSON.parse(localStorage.getItem("localWindowName") || "[]");
  };
 
 
  const closeWindows = () => {
    let lwn = getLWN();
    for (let i = 0; i < lwn.length; i++) {
      let x = window.open("", lwn[i]);
      x?.close();
    }
    if(window.name != CMdSPortals ){
      if(localStorage.getItem('username')){
        if (lwn.indexOf(window.name) == -1) {
          if(window.opener){
            window.open("",CMdSPortals)
            window.close()
          }
          window.location = "/"
        }      
      }
}
  };
  const postToCMDSPortals = (c) => {
    const now = Date.now();
    const isSessionMsg = c === GLOBAL_SESSION_TIMEOUT_WARNING_MESSAGE || c === GLOBAL_SESSION_TIMEOUT_WARNING_DISMISSED;
    if (isSessionMsg && now - lastPostToPortalsTime.current < 1000) return;
    if (isSessionMsg) lastPostToPortalsTime.current = now;
    let lwn = getLWN();
    const toRemove = [];
    for (let i = 0; i < lwn.length; i++) {
      try {
        let x = window.open("", lwn[i]);
        if (x && !x.closed) {
          try {
            if (x.location.href === 'about:blank' || x.location.href === '') {
              x.close();
              toRemove.push(lwn[i]);
              continue;
            }
          } catch (locErr) {}
          x.postMessage(c, '*');
        }
      } catch (e) {}
    }
    if (toRemove.length > 0) {
      const updated = lwn.filter((n) => !toRemove.includes(n));
      localStorage.setItem("localWindowName", JSON.stringify(updated));
    }
  };
  const checkTabClose = (s, n) => {
    setTimeout(() => {
      if (s.closed) {
        let lwn = getLWN();
        if (lwn.indexOf(n) > -1) {
          lwn.splice(lwn.indexOf(n), 1);
          localStorage.setItem("localWindowName", JSON.stringify(lwn));
        }
      }
    }, 100);
  };
  React.useEffect(() => {
    const isParentTab = window.name === CMdSPortals || window.name === SELECT_ORG || window.location.pathname === '/' || window.location.pathname === PROVIDER_PORTAL_LP || window.location.pathname === USER_SEARCH || window.location.pathname === MANAGE_ACCOUNT_ADDEDIT || window.location.pathname === MY_ACCOUNT;
    if (!isParentTab) {
      window.addEventListener('beforeunload', e => {
      if(localStorage.getItem('username')){
        let lwn = getLWN();
        if (lwn.indexOf(window.name) > -1) {
          lwn.splice(lwn.indexOf(window.name), 1);
          localStorage.setItem("localWindowName", JSON.stringify(lwn));
        }      
      }
      window.onbeforeunload = null;
      window.close()
      e.stopImmediatePropagation();
    })
    window.addEventListener("storage", (event) => {
       if (event.key === "isLogOutClean"){
        if (localStorage.getItem("isLogOutClean") === "true") {
          window.close()
        }
      }
    });
  }
else {
  const normalizeOrigin = (o) => {
    if (o == null || o === "") return "";
    return String(o)
      .trim()
      .replace(/^['"]+|['"]+$/g, "")
      .replace(/\/$/, "");
  };
  const isAllowedChildOrigin = (origin) => {
    const n = normalizeOrigin(origin);
    const sameOrigin = n === normalizeOrigin(window.location.origin || "");
    return (
      sameOrigin ||
      n === normalizeOrigin(process.env.REACT_APP_CLAIMS_URL) ||
      n === normalizeOrigin(process.env.REACT_APP_FIN_URL) ||
      n === normalizeOrigin(process.env.REACT_APP_WP_URL) ||
      n === normalizeOrigin(process.env.REACT_APP_NCCI_URL) ||
      n === normalizeOrigin(process.env.REACT_APP_PRODUCT_URL)
    );
  };
  /** Child tab opened via portal window.open — works even when REACT_APP_*_URL env does not match dev URL. */
  const isChildWindowOpenedByThisTab = (event) => {
    try {
      return (
        event.source &&
        event.source !== window &&
        event.source.opener === window
      );
    } catch (err) {
      return false;
    }
  };
  window.addEventListener("message", (e) => {
    if (e.data === "sessionActivity" || (e.data && typeof e.data === "object" && e.data.type === "SESSION_ACTIVITY")) {
      try {
        localStorage.setItem(CMDS_LAST_ACTIVITY_TS, String(Date.now()));
      } catch (err) {}
      setShowSessionTimeoutPopup(false);
    }
    if (e.data === GLOBAL_SESSION_TIMEOUT_STAY_SIGNED_IN) {
      try {
        localStorage.setItem(CMDS_LAST_ACTIVITY_TS, String(Date.now()));
        localStorage.setItem('cmds_session_timeout_warning', 'dismissed');
      } catch (err) {}
      setShowSessionTimeoutPopup(false);
      postToCMDSPortals(GLOBAL_SESSION_TIMEOUT_WARNING_DISMISSED);
    }
    // Ignore 'logOut' from child origins: an idle child tab's local timeout would otherwise log out
    // the whole app while user is active in another tab. Children send userRequestedLogout when
    // user explicitly clicks logout (profile card, etc.).
    if (e.data === "logOut" && !isAllowedChildOrigin(e.origin)) {
      logOut();
    }
    if (
      e.data === USER_REQUESTED_LOGOUT &&
      (isAllowedChildOrigin(e.origin) || isChildWindowOpenedByThisTab(e))
    ) {
      logOut();
    }
    if (isAllowedChildOrigin(e.origin) || isChildWindowOpenedByThisTab(e)) {
      if (e?.data && typeof(e.data)==="string" && e.data.includes('checkTabClose')) {
        if(e.data.split('-')[1]){
          checkTabClose(e.source, e.data.split('-')[1]);
        }
      }
    }
    const sessionIframeEl = document.getElementById(CMDS_SESSION_IFRAME_ID);
    const isFromSessionIframe = sessionIframeEl && e.source === sessionIframeEl.contentWindow;
    const isSessionTimeoutFromIframe = isFromSessionIframe || e.origin === window.location.origin || e.origin === 'null';
    if (isSessionTimeoutFromIframe) {
      if (e.data === GLOBAL_SESSION_TIMEOUT_WARNING_MESSAGE) {
        setShowSessionTimeoutPopup(true);
        postToCMDSPortals(GLOBAL_SESSION_TIMEOUT_WARNING_MESSAGE);
      }
      if (e.data === GLOBAL_SESSION_TIMEOUT_MESSAGE) {
        setShowSessionTimeoutPopup(false);
        if (!hasLoggedOut.current) {
          console.log("PARENT: received GLOBAL_SESSION_TIMEOUT_MESSAGE message from iframe", e.data);
          logOut();
        }
      }
    }
  });
  window.addEventListener("storage", (event) => {
    if (event.key === "username") {
      if (isLogin && !localStorage.getItem("username")) {
        logOutClean();
      }
    }  else if (event.key === "initLogin") {
      if (localStorage.getItem("initLogin") === "true") {
        window.location = "/";
      }
    } else if (event.key === "isLogOutClean"){
      if (localStorage.getItem("isLogOutClean") === "true") {
        window.location = "/";
      }
    } else if (event.key === 'cmds_session_timeout_warning' && (event.newValue === 'dismissed' || event.newValue === null)) {
      setShowSessionTimeoutPopup(false);
    }
  });
}
  });
 
  React.useEffect(() => {
    if (!loginState || isLogin) {
      return;
    }
    const expiryM = successData.passwordExpiry
      ? momentFromUnknown(successData.passwordExpiry)
      : null;
    let diff =
      expiryM && expiryM.isValid()
        ? expiryM.diff(moment(), 'days')
        : 90;
    setspinnerLoader(true);    
    setTimeout(() => {
    setspinnerLoader(false);
    // Normal Login which is > 7 for password expiry
    if(diff > process.env.REACT_APP_PASSWORD_EXPIRY_DAYS && loginState && !successData.forcePasswordChange
      && (successData.userType !== 'WP' || localStorage.getItem('impStateLoginInd') !== 'Y')){
      setIsLogin(true)
      setspinnerLoader(false);      
      setWarningMessages([]);
      setErrorMessages([]);
      setInfoMessages([]);
      setSuccessMessages([]);
    }else if(diff > process.env.REACT_APP_PASSWORD_EXPIRY_DAYS && loginState && !successData.forcePasswordChange
      && (successData.userType == 'WP' || successData.userType == 'WPR') &&  localStorage.getItem('impStateLoginInd') == 'Y'){
      setIsLogin(true)
      setspinnerLoader(false);      
      setWarningMessages([]);
      setErrorMessages([]);
      setInfoMessages([]);
      setSuccessMessages([]);
    }
    else if(diff <= process.env.REACT_APP_PASSWORD_EXPIRY_DAYS && loginState && !successData.forcePasswordChange){
    // Normal Login which is < 7 for password expiry
      setspinnerLoader(false);
      setIsLogin(true);      
      setErrorMessages([]);
      setInfoMessages([]);
      setSuccessMessages([]);
      setWarningMessages([ "Your Password is about to expire in " +
      `${diff}`+
      " days.",])
    }else if(successData.forcePasswordChange && loginState) {
      setLoginType('')
      setIsPassword(true);
      setspinnerLoader(false);
      setIsLogin(false);
      setErrorMessages([]);
      setInfoMessages([]);
      setSuccessMessages([]);
      setWarningMessages([ErrorMsgConstants.FIRST_TIME_LOGIN]);
    }
  },2000)
  },[loginState, isLogin, successData]);
 
  const networkErrorHandler = () => {
    setspinnerLoader(false);
    setErrorMessages([ERR_PROCESSING_REQ]);
    setTimeout(() => setErrorMessages([]), 3000);
  };

  const networkErrorHandlerRef = useRef(networkErrorHandler);
  networkErrorHandlerRef.current = networkErrorHandler;

  React.useEffect(() => {
    const requestInterceptorId = axios.interceptors.request.use(
      async function (config) {
        config.headers.Username = localStorage.getItem('username');
        config.headers.Authorization = localStorage.getItem('accessToken');
        config.headers["X-CMDS-APP-CODE"] = X_CMDS_APP_CODE;
        return config;
      },
      function () {
        networkErrorHandlerRef.current();
      }
    );

    const responseInterceptorId = axios.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        const status = error?.response?.status;
        const data = error?.response?.data;
        const msg = typeof data === 'string' ? data : (data?.message || data?.errorMessage || '');
        const isInvalidToken = /invalid.*(access\s*)?token|token.*invalid|unauthorized/i.test(msg);
        if (status === 401 || status === 403 || (status === 400 && isInvalidToken)) {
          return Promise.reject(error);
        }
        networkErrorHandlerRef.current();
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.request.eject(requestInterceptorId);
      axios.interceptors.response.eject(responseInterceptorId);
    };
  }, []);
 
  React.useEffect(() => {
    if (isLogin) {
      localStorage.setItem("isLogOutClean","false")
    }
  }, [isLogin]);
  React.useEffect(() => {
    sessionStorage.removeItem('otpPendingSession');
    if (uid) {
      setspinnerLoader(true);
      ssoLogin();
    } else if (code) {
      setspinnerLoader(true);
      localStorage.setItem("code", code);
      window.location = "/";
    } else if(fromOrg) {
      const url = new URL(window.location);
      url.searchParams.delete('fromOrg');
      window.history.replaceState({}, '', url);
    } else if (localStorage.getItem("username")) {
      setspinnerLoader(true);
      getAppInfo();
    } else if (scode) {
      setspinnerLoader(true);
      getAccessToken(scode);
    }
    else if (localStorage.getItem("logOutNM") === "true") {
      localStorage.setItem("logOutNM", "false")
      window.open(process.env.REACT_APP_LANDING_SCREEN_URL, '_self');
    }
    document.title = CMdSPortals;
  }, []);
  const handleAuthError = (error, fromTokenValidationOnLoad = false) => {
    const status = error?.response?.status;
    const data = error?.response?.data;
    const msg = typeof data === 'string' ? data : (data?.message || data?.errorMessage || '');
    const isInvalidToken = /invalid.*(access\s*)?token|token.*invalid|unauthorized/i.test(msg);
    setspinnerLoader(false);
    if (fromTokenValidationOnLoad || status === 401 || status === 403 || (status === 400 && isInvalidToken)) {
       setErrorMessages([]);
       logOut();
    } else {
      setErrorMessages([ErrorMsgConstants.ERROR_OCCURED_DURING_TRANSACTION]);
    }
  };
 
  const getAccessToken = (c) => {
    var data = qs.stringify({
      grant_type: process.env.REACT_APP_GRANT_TYPE,
      code: c,
      redirect_uri: window.location.href,
      client_id: process.env.REACT_APP_CLIENT_ID,
    });
    var config = {
      method: "post",
      url: process.env.REACT_APP_ACCESS_TOKEN,
      headers: {
        Authorization: process.env.REACT_APP_AUTHORIZATION_CODE,
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: data,
    };
  const acccessTokenAxios = axios.create();
  acccessTokenAxios(config)
      .then(function (response) {        
        getAppInfo(response);
      })
      .catch(function (error) {
        handleAuthError(error);
      });
  };
  const getAppInfo = (r) => {
    let d;
    let data;
    if (r) {
      d = parseJwt(r.data.id_token);
      data = {
        username: d.sub,
        accessToken: r.data.access_token,
        refreshToken: r.data.refresh_token,
      };
    }
    else{
      data = {
        username: localStorage.getItem("username"),
        accessToken: localStorage.getItem("accessToken"),
        refreshToken: localStorage.getItem("refreshToken"),
      };
    }
    var config = {
      method: "post",
      url: `${process.env.REACT_APP_SECURITY_HOST}security/auth/tokenappinfo`,
      data: data,
    };
    axios(config)
      .then(function (r) {
        const d = parseJwt(r.data.data);
        if(process.env.REACT_APP_LOGIN_THROUGH === TextConst.PRODUCT && d?.forcePasswordChange){          
          setIsLogin(false);
          dispatch(setForcePasswordChange(true));      
        }else{
          setIsLogin(true);
        }        
        setUser(`${d.lastname}, ${d.firstname}`);
        localStorage.removeItem('code');
        localStorage.setItem("user", `${d.lastname}, ${d.firstname}`);
        localStorage.setItem("initLogin", "true");
        localStorage.setItem("orgList", JSON.stringify(d?.orglist));
        sessionStorage.setItem("accessToken", r.data.accessToken);
        safeLocalStorage(
          'set',
          'loginState',
          JSON.stringify({
            loginUserName: d?.username,
            loginUserId: d?.userId,
            userPrivileges: d?.roles?.split(','),
            time: Date.now(),
            applist: d?.applist,
            passwordExpiry: d?.passwordExpiry,
            firstName: d?.firstname,
            lastName: d?.lastname,
            forcePasswordChange: d?.forcePasswordChange,
            locked: d?.locked,
            email:d?.email,
            orgId: d?.organization,
            orglist: d?.orglist,
            userType: d?.userType,
            clientMappingKey: d?.clientMappingKey,
          })
        );
        setSuccessData(d);
        setLoginState(true);
        dispatch(getStateImplCode());            
        storeCred(
          r.data.accessToken,
          r.data.refreshToken,
          d.username,
          r.data.expiresInSeconds,
          r.data.ssoToken
        );
        storeAppInfo(d?.applist || []);
        setAppList(d?.applist || []);        
        setspinnerLoader(false);              
      })
      .catch(function (error) {
        handleAuthError(error, !r);
      });
  };
  const refreshToken = (rToken, userName) => {
    axios
      .get(
        `${process.env.REACT_APP_SECURITY_HOST}security/token/refresh/${userName}/${rToken}`
      )
      .then((r) => {
        const d = parseJwt(r.data.data);
        storeCred(
          r.data.accessToken,
          r.data.refreshToken,
          d.username,
          r.data.expiresInSeconds,
          r.data.ssoToken,
          true
        );
      })
      .catch((e) => {
        handleAuthError(e);
      });
  };
  const ssoLogin = () => {
    window.location.replace(process.env.REACT_APP_SSO_LOGIN);
  };
 
  const openTab = (url, target, closeTabOnLogout = false) => {
    if (downtime) {
      return false;
    }
    if(!url || typeof url !== "string") return false;
    const wn = String(Date.now())
    const name = target == SELECT_ORG ? SELECT_ORG : wn;
    const openedWindow = window.open("", name);
    if(!openedWindow) return false;
    try{
      openedWindow.location.replace(url);
    }catch(e){
      openedWindow.location.href = url;
    }
    if (!closeTabOnLogout) {
        let lwn = getLWN();
        if(!lwn.includes(name)) lwn.push(name);
        localStorage.setItem("localWindowName", JSON.stringify(lwn));
    }
    return openedWindow;
 };
 
  const getUrl = (h) => {
    const accessToken = localStorage.getItem('accessToken');
    const refreshToken = localStorage.getItem('refreshToken');
    const username = localStorage.getItem('username');
    const impStateLoginInd = localStorage.getItem('impStateLoginInd');
    const normalUser = localStorage.getItem('isNormalUser')
    const newUrl = navigateToCMdSApp(h, username, accessToken, refreshToken, impStateLoginInd, normalUser);
    return newUrl
  };
  const openManageAccont = () => {
    localStorage.setItem("Checked", "yes");
    const parentOrigin = window.location.origin || '';
    const manageUserSearchUrl = (parentOrigin ? parentOrigin.replace(/\/$/, '') : '') + getUrl(USER_SEARCH);
    openTab(manageUserSearchUrl, '_blank');
  };
 
  const getSessionTimeoutManagerSrcdoc = () => {
    const CHECK_INTERVAL_MS = 30000;
    const warningBeforeMinutes = Number(process.env.REACT_APP_SESSION_TIMEOUT_WARNING_BEFORE_MINUTES) || 5;
    const WARNING_BEFORE_MS = warningBeforeMinutes * 60 * 1000; // e.g. 2 min before => popup at 3rd min when timeout is 5 min
    return `<!DOCTYPE html><html><head><meta charset="utf-8"></head><body><script>
      (function () {
        var KEY_LAST = '${CMDS_LAST_ACTIVITY_TS}';
        var KEY_MIN = '${CMDS_SESSION_TIMEOUT_MINUTES}';
        var MSG = '${GLOBAL_SESSION_TIMEOUT_MESSAGE}';
        var WARN_MSG = '${GLOBAL_SESSION_TIMEOUT_WARNING_MESSAGE}';
        var warned = false;
 
        function getTimeoutMs() {
          var m = parseInt(localStorage.getItem(KEY_MIN), 10);
          return (isNaN(m) || m <= 0 ? 30 : m) * 60 * 1000;
        }
 
        function check() {
          try {
            var ts = localStorage.getItem(KEY_LAST);
            if (!ts) return;
            var last = parseInt(ts, 10);
            if (isNaN(last)) return;
            var elapsed = Date.now() - last;
            var to = getTimeoutMs();
 
            // reset warning if user became active again
            if (elapsed < to - ${WARNING_BEFORE_MS}) warned = false;
 
            if (elapsed >= to && window.parent !== window) {
              window.parent.postMessage(MSG, "*");
            } else if (elapsed >= to - ${WARNING_BEFORE_MS} && !warned && window.parent !== window) {
              warned = true;
              window.parent.postMessage(WARN_MSG, "*");
            }
          } catch (e) {}
        }
 
        setInterval(check, ${CHECK_INTERVAL_MS});
        check();
        // When tab becomes visible again, re-check immediately (background tabs throttle setInterval)
        document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') check(); });
      })();
    <\/script></body></html>`;
  };
 
  const ensureSessionTimeoutIframeWithStorage = () => {
    const timeoutMinutes = Number(process.env.REACT_APP_SESSION_TIMEOUT_MINUTES) || 30;
    try {
      localStorage.setItem(CMDS_LAST_ACTIVITY_TS, String(Date.now()));
      localStorage.setItem(CMDS_SESSION_TIMEOUT_MINUTES, String(timeoutMinutes));
    } catch (e) {}
    if (sessionTimeoutIframeRef.current && document.getElementById(CMDS_SESSION_IFRAME_ID)) return;
    var iframeEl = document.createElement("iframe");
    iframeEl.setAttribute("id", CMDS_SESSION_IFRAME_ID);
    iframeEl.setAttribute("title", "Session Timeout Manager");
    iframeEl.style.display = "none";
    iframeEl.srcdoc = getSessionTimeoutManagerSrcdoc();
    document.body.appendChild(iframeEl);
    sessionTimeoutIframeRef.current = iframeEl;
  };
 
  React.useEffect(() => {
    const isParentTab = window.name === CMdSPortals || window.name === SELECT_ORG || window.location.pathname === '/' || window.location.pathname === PROVIDER_PORTAL_LP || window.location.pathname === USER_SEARCH || window.location.pathname === MANAGE_ACCOUNT_ADDEDIT || window.location.pathname === MY_ACCOUNT;
    if (isParentTab && isLogin) {
      ensureSessionTimeoutIframeWithStorage();
    }
  }, [isLogin]);
 
  React.useEffect(() => {
    const isParentTab = window.name === CMdSPortals || window.name === SELECT_ORG || window.location.pathname === '/' || window.location.pathname === PROVIDER_PORTAL_LP || window.location.pathname === USER_SEARCH || window.location.pathname === MANAGE_ACCOUNT_ADDEDIT || window.location.pathname === MY_ACCOUNT;
    if (!isParentTab || !isLogin) return;
    let debounce = null;
    const DEBOUNCE_MS = 300;
    const updateActivity = () => {
      if (debounce) clearTimeout(debounce);
      debounce = setTimeout(() => {
        try {
          localStorage.setItem(CMDS_LAST_ACTIVITY_TS, String(Date.now()));
        } catch (e) {}
        debounce = null;
      }, DEBOUNCE_MS);
    };
    const events = ['click', 'keydown', 'mousemove', 'scroll'];
    events.forEach((ev) => window.addEventListener(ev, updateActivity));
    return () => {
      events.forEach((ev) => window.removeEventListener(ev, updateActivity));
      if (debounce) clearTimeout(debounce);
    };
  }, [isLogin]);

  React.useEffect(() => {
    if (!isLogin) return;
    const warningBeforeMinutes = Number(process.env.REACT_APP_SESSION_TIMEOUT_WARNING_BEFORE_MINUTES) || 5;
    const WARNING_BEFORE_MS = warningBeforeMinutes * 60 * 1000;
    const CHECK_INTERVAL_MS = 30000;
    const runSessionTimeoutCheck = () => {
      try {
        const ts = localStorage.getItem(CMDS_LAST_ACTIVITY_TS);
        if (!ts) return;
        const last = parseInt(ts, 10);
        if (isNaN(last)) return;
        const elapsed = Date.now() - last;
        const m = parseInt(localStorage.getItem(CMDS_SESSION_TIMEOUT_MINUTES), 10);
        const timeoutMs = (isNaN(m) || m <= 0 ? 30 : m) * 60 * 1000;
        if (elapsed >= timeoutMs) {
          setShowSessionTimeoutPopup(false);
          if (!hasLoggedOut.current) logOut();
        } else if (elapsed >= timeoutMs - WARNING_BEFORE_MS) {
          setShowSessionTimeoutPopup(true);
          postToCMDSPortals(GLOBAL_SESSION_TIMEOUT_WARNING_MESSAGE);
        }
      } catch (e) {}
    };
    const handleVisibility = () => {
      if (document.visibilityState === 'visible') runSessionTimeoutCheck();
    };
    document.addEventListener('visibilitychange', handleVisibility);
    const intervalId = setInterval(() => {
      if (document.visibilityState === 'visible') runSessionTimeoutCheck();
    }, CHECK_INTERVAL_MS);
    runSessionTimeoutCheck();
    return () => {
      document.removeEventListener('visibilitychange', handleVisibility);
      clearInterval(intervalId);
    };
  }, [isLogin]);
 
  const handleAppOnClick = (app) => {
    const isParentTab = window.name === CMdSPortals || window.name === SELECT_ORG || window.location.pathname === '/' || window.location.pathname === PROVIDER_PORTAL_LP || window.location.pathname === USER_SEARCH || window.location.pathname === MANAGE_ACCOUNT_ADDEDIT || window.location.pathname === MY_ACCOUNT;
    if (isParentTab && isLogin) {
      ensureSessionTimeoutIframeWithStorage();
    }
    if (app.id === "MANAGEACCOUNT" || app.id === "MANAGEACCOUNTR") {
      openManageAccont();
    } else if(app.title == "Provider Claims Portal" && localStorage.getItem('impStateLoginInd') == 'Y'){
      localStorage.setItem("Checked","yes")
      const parentOrigin = window.location.origin || '';
      const selectOrgUrl = (parentOrigin ? parentOrigin.replace(/\/$/, '') : '') + getUrl(PROVIDER_PORTAL_LP);
      openTab(selectOrgUrl, SELECT_ORG)
    } else {
      const url = process.env[app.urlKey];
      app.useDirectUrl ? openTab(url, '_blank', app.useDirectUrl) : openTab(getUrl(url), '_blank');
    }
  };  
  const logOut = () => {
    if (hasLoggedOut.current) return;
    hasLoggedOut.current = true;
    postToCMDSPortals("logOut");
    closeWindows();
    securityLogout();
  };

  const resetState = (redirectUserType, redirectIsNormalUser) => {
    setspinnerLoader(false);
    const userType = redirectUserType !== undefined ? redirectUserType : localStorage.getItem('userType');
    const isNormalUser = redirectIsNormalUser !== undefined ? redirectIsNormalUser : localStorage.getItem('isNormalUser');
    const envData = (process.env.REACT_APP_USER_PROFILE_WP_CHECK || '').split(',');
    const sicamData = (process.env.REACT_APP_USER_PROFILE_SICAM_CHECK || '').split(',');

  // Case 1: WP/WPR redirect (works for sso)
  if (!isNormalUser && envData.includes(userType)) {
    const wpRedirect = (process.env.REACT_APP_WP_REDIRECT || '').replace(/^['"]|['"]$/g, '');
    window.location = wpRedirect;
    return;
  }
  // Case 2: SICAM redirect (only when sso)
  if (!isNormalUser && sicamData.includes(userType)) {
    window.location = (process.env.REACT_APP_SICAM_REDIRECT).replace(/^['"]|['"]$/g, '');
    return;
  }
  // Case 3: Generic logout redirect
  if (process.env.REACT_APP_LOGIN_THROUGH !== TextConst.PRODUCT &&
      process.env.REACT_APP_LOGOUT_REDIRECT) {
    window.location = process.env.REACT_APP_LOGOUT_REDIRECT;
    return;
  }
  // Default fallback
      window.location = '/';
  };

  const securityLogout = () => {
    setspinnerLoader(true);
    axios
      .post(`${process.env.REACT_APP_SECURITY_HOST}security/auth/logout`, {
        username: localStorage.getItem("username"),
        accessToken: localStorage.getItem("accessToken"),
        ssoToken: localStorage.getItem("ssoToken"),
      })
      .then((r) => {
        samlLogout();
      })
      .catch((e) => {
        setErrorMessages([ErrorMsgConstants.ERROR_OCCURED_DURING_TRANSACTION]);
        setspinnerLoader(false);
        logOutClean();
      });
  };
  const logOutClean = () => {
    const loginState = JSON.parse(localStorage.getItem('loginState') || '{}');
    const userType = (loginState.userType || '').toUpperCase();
    const isNormalUser = localStorage.getItem('isNormalUser');
    deleteAllCookies();
    postToCMDSPortals("logOut");
    closeWindows();
    clearInterval(tokenIntervalID);
    window.localStorage.clear();
    window.sessionStorage.clear();
    localStorage.setItem("initLogin", "false");
    localStorage.setItem("Checked","no");
    localStorage.setItem("isLogOutClean","true");
    resetState(userType, isNormalUser);
  };
  const iframeLogouts = (urls=[]) => {
    try{
      urls.forEach((url, index) => {
      let element = document.createElement("iframe");
      element.setAttribute("id", `${index}_samlframe`);
      document.body.appendChild(element);
      element.style.display = "none";
      element.src = url;
    });
    }catch(e){
      console.log(e);
    }        
  };  
  const replaceDynamicWithIam = (url='') => {
    return url.replace(/\.[^.]+\.apps/, '.iam.apps');
  };
  const samlLogout = () => {
    setspinnerLoader(true);
    const hasNCCI = appList.some(app => app.id == "NCCI")
    if(hasNCCI){
      iframeLogouts([
        process.env.REACT_APP_SSO_LOGOUT,
        `${replaceDynamicWithIam(process.env.REACT_APP_NCCI_URL)}/am/XUI/?realm=/claims#/logout`
      ]);
    }
    setTimeout(()=>{
      logOutClean();
    },1000);
  };
  const deleteAllCookies = () => {
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var eqPos = cookie.indexOf("=");
      var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + `=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${process.env.REACT_APP_COOKIE_DOMAIN}`;
    }
  };  
  const openFooterInShell = (linkName) => {
    setFooterLinks(true);
    setFooterLinksName(linkName);
  };

  const handleLink = (linkName) => {
    if (linkName === "SiteMap") {
      history1.push("/SiteMap");
      return;
    }
    if (
      linkName == "PrivacyPolicy" ||
      linkName === "TermsofUse" ||
      linkName === "BrowserRequirements" ||
      linkName === "AccessibilityCompliance"
    ) {
      openFooterInShell(linkName);
    }
  };
 
  // My Account Functionality
  const [isMyAccount,setIsMyAccount] = React.useState(false);
 
  const navigateToMyAccount =()=>{      
    callingGetDetails()
    setIsMyAccount(true);
  }
 
  const callingGetDetails = () => {
    let loginState = JSON.parse(localStorage.getItem('loginState'));
    getDetails(loginState?.loginUserId)
  }
  React.useEffect(() => {
  if (userDetailsData && userDetailsData?.statusCode === '01' && isMyAccount) {
    setErrorMessages([])
    setspinnerLoader(false)
    localStorage.setItem("Checked","yes")
    localStorage.setItem("userDetails", JSON.stringify(userDetailsData?.responseObject));
    const parentOrigin = window.location.origin || '';
    const myAccountUrl = (parentOrigin ? parentOrigin.replace(/\/$/, '') : '') + getUrl(MY_ACCOUNT);
    openTab(myAccountUrl, '_blank')
    setIsMyAccount(false);
  } else if (userDetailsData && userDetailsData?.statusCode !== '01' && userDetailsData?.statusDescription !== "Success" && isMyAccount) {
    setspinnerLoader(false)
    setErrorMessages([ErrorMsgConstants.ERROR_OCCURED_DURING_TRANSACTION])
}
  }, [userDetailsData, isMyAccount]);

const getLogoutLabel = () => {
  const loginState = JSON.parse(localStorage.getItem('loginState') || '{}');
  const userType = (loginState.userType || '').toUpperCase();
  const isNormalUser = localStorage.getItem('isNormalUser'); // "true" | "false" | null (key missing)

  // When isNormalUser is null: !null === true, so Case 1/2 can run. When "true"/"false": !"true" is false, so we skip to Case 3 or Default.
  // Only treat as WP/SICAM when we have a non-empty userType so we don't match on empty string.
  const envData = (process.env.REACT_APP_USER_PROFILE_WP_CHECK || '').split(',');
  if (!isNormalUser && userType && envData.includes(userType)) {
    return process.env.REACT_APP_WP_LOGOUT;
  }
  if (!isNormalUser && userType &&
      (process.env.REACT_APP_USER_PROFILE_SICAM_CHECK || '').toUpperCase() === userType) {
    return process.env.REACT_APP_SICAM_LOGOUT;
  }
  // When isNormalUser is truthy (e.g. "true") — show default logout label
  if (isNormalUser) {
    return process.env.REACT_APP_LOGOUT;
  }
  // Default: isNormalUser null/empty and userType not WP/SICAM
  return process.env.REACT_APP_LOGOUT;
}

  const FOOTER_SHELL_HOME_PATHS = [MY_ACCOUNT, USER_SEARCH, MANAGE_ACCOUNT_ADDEDIT];
  const footerLegalHomeReturnPath = FOOTER_SHELL_HOME_PATHS.includes(location.pathname)
    ? `${location.pathname}${location.search || ''}`
    : undefined;

 
  return (
  <>
        {spinnerLoader ? <Spinner /> : null}
{footerLinks ? <FooterLinks footerLinksName={footerLinksName} homeReturnPath={footerLegalHomeReturnPath} />
 :
  <main className="before-login ">
      <Header isLogin = {isLogin} setIsLogin ={setIsLogin} showLink={window.name != CMdSPortals?['Home']:showLink} navigateToMyAccount={navigateToMyAccount} checked={checked} logOut={logOut}/>  
  <div className={`normallogin-container ${checked && window.name != CMdSPortals && "main-body"}`}>
    {isLogin && (downtime || upComingDowntime) ? (
      <div className={`alert alert-${downtime && 'danger' || 'warning'} sso-page-alerts`}>
        <ul className="m-0">
          {<li>{downtime ? donwTimeMsg.replace('will be', 'is') : donwTimeMsg}</li>}
        </ul>
      </div>
    ) : null}
     {window.location.pathname != USER_SEARCH && window.location.pathname != MANAGE_ACCOUNT_ADDEDIT && warningMessages.length > 0 ? (
        <div className="alert alert-warning custom-alert" role="alert">
          {warningMessages.map(message => (
            <li>{message}</li>
          ))}
        </div>
      ) : null}
     {isLogin && infoMessages.length > 0 ? (
        <div className="alert alert-info custom-alert" role="alert">
          {infoMessages.map(message => (
            <li>{message}</li>
          ))}
        </div>
      ) : null}
      {successMessages.length > 0 ? (
        <div className="alert alert-success custom-alert" role="alert">
          {successMessages.map(message => (
            <li>{message}</li>
          ))}
        </div>
      ) : null}
      {errorMessages.length > 0 ? (
        <div className="alert alert-danger custom-alert" role="alert">
          {errorMessages.map(message => (
            <li>{message}</li>
          ))}
        </div>
      ) : null}
    <div className="container-fluid h-100">
    {
       checked == 'yes' &&  localStorage.getItem('username') && localStorage.getItem('accessToken') && window.name != CMdSPortals && window.location.pathname != '/'
      ?
      <ManageUser accessToken={localStorage.getItem('accessToken')} username={localStorage.getItem('username')}/>
      :
      <div className="row h-100 white-bg">
        <section className="col-lg-8 col-md-6 col-sm-12 banner-panel">
          <div className="log-courosal">
            <div className="log-banner">
              <img
                title="Login Banner"
                src="./images/banner.png"
                alt="login image"
              />
            </div>
          </div>
          <div className="row h-100 position-relative">
            <div className="col-md-8 col-xs-12 text-center">
              <div className="carousel-content py-2">
                <div className="carousel-text">
                  <h4> Welcome to</h4>
                  <h1>{window.name= CMdSPortals}</h1>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-xs-12 px-0">
              <div className="log-action-center">
                <div className="log-notifications">
                  <h3 className="notify-heading purple-brd"> Updates</h3>
                  <div className="clear-block">
                    {/* <div className="notify-link">Latest Policy News</div> */}
                  </div>
                </div>
 
                <div className="log-notifications">
                  <h3 className="notify-heading"> Quick Links</h3>
                  <div className="clear-block">
                    <a  className="notify-link"
                        target="_blank"
                        rel="noopener noreferrer"
                        href = 'https://www.hca.nm.gov/mco-systems-manual/'
                    >
                        Turquoise Claims Manual
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
 
        <section className="col-lg-4 col-md-6 col-sm-12 portal-panel">
          <div className="portal-wrapper">
            {isLogin ? (
              <>
                <div className="set-logOut">
                  <div className="welcome-user">
                    <h1>Hello {user ? user : userData?.lastName && userData?.firstName ? userData.lastName + ' ' + userData?.firstName : ''}!</h1>
                    <p className="heading-text">
                      Select the suitable portal of your choice
                    </p>
                  </div>
                  <div className="portal-wrapper-inner scrollable-container">
                    {appList.length > 0 && appList.map((app) => {
                        return (
                          <div className={`portal-menu ${downtime && "error-state"}`} key={app.id}>
                            <div
                              title={app.title}
                              className="portal-menu-item"
                              onClick={() => handleAppOnClick(app)}
                            >
                              <span className={`portal-menu-icon ${app.iconClass}`}>&nbsp;</span>
                              <div className="portal-tab-txt">
                                <p className="portal-menu-title">{app.title}</p>
                                <span className="portal-menu-desc">{app.description}</span>
                              </div>
                            </div>
                          </div>
                        );
                    })}
                  </div>
                </div>
                <div className="user-logout text-center">
                  <div className="logOut-btn mr-3" onClick={navigateToMyAccount}>
                    <span className="my-account"></span>
                    My Account
                  </div>
                  <div className="logOut-btn" onClick={logOut}>
                    <span className="fa-solid fa-right-from-bracket"></span>
                    {getLogoutLabel()}
                  </div>
                </div>
              </>
            ) :
              <>
              {logInType === TextConst.OTP_LOGIN ?
                <OTPPage
                  username={values.username}
                  verifyOtpAndCompleteLogin={verifyOtpAndCompleteLogin}
                  onResendOtp={handleResendOtp}
                  onSessionExpire={handleOtpSessionExpire}
                  resendPermanentlyDisabled={resendOtpDisabled}
                />
              : logInType === TextConst.NORMAL_LOGIN ?
                <LoginPage
                  setWarningMessages ={setWarningMessages}
                  setErrorMessages={setErrorMessages}
                  logOut={logOut}
                  logOutClean={logOutClean}
                  setInfoMessages = {setInfoMessages}
                  infoMessages={infoMessages}
                  setspinnerLoader={setspinnerLoader}
                  setAppList={setAppList}
                  setUser={setUser}
                  appList={appList}
                  storeAppInfo={storeAppInfo}
                  setIsLogin={setIsLogin}
                  isLogin={isLogin}
                  setSuccessMessages={setSuccessMessages}
                  storeCred={storeCred}
                  setLoginType={setLoginType}
                  setIsPassword={setIsPassword}
                  setLoginState={setLoginState}
                  loginState={loginState}
                  values={values}
                  setValues={setValues}
                  onLogonSubmit={handleLogonSubmit}
                  errors={{invalidUsrPassErr}}
                />
              : isPassword ?
                <ChangePassword
                  setIsPassword = {setIsPassword}
                  setIsLogin ={setIsLogin}
                  logOut={logOut}
                  setInfoMessages={setInfoMessages}
                  setWarningMessages={setWarningMessages}
                  setErrorMessages = {setErrorMessages}
                  setAppList ={setAppList}
                  setSuccessMessages={setSuccessMessages}
                  setspinnerLoader={setspinnerLoader}
                  setValues={setValues}
                  values={values}
                  submitSuccess={submitSuccess}
                  setChangeState={setChangeState}
                  setformValue={setformValue}
                  formValue={formValue}
                  defaultFormValue={defaultFormValue}
                  setLoginType={setLoginType}
                  setLoginState={setLoginState}
                  redirectToLandingPage={redirectToLandingPage}
                  requireReLoginAfterPasswordChange={isV2PasswordExpiredFlow}
                  onPasswordChangedReLogin={handleV2PasswordChangedReLogin}
                />
              :
                <NewLogin onNormalLoginSelect={onNormalLoginSelect} />
            }</>
            }                
          </div>
        </section>
      </div>
      }
    </div>
  </div>
</main>
}
 
<footer className="mt-0">      
            <div className="row m-0 mb-2 align-center">
              <div className="col-md-6">
                <p className="footer-text my-2">
                  ©{new Date().getFullYear()} Conduent, Inc. All rights reserved. Conduent and
                  Conduent Agile Star are trademarks of Conduent, Inc.
                  and/or its subsidiaries in the United States and/or other
                  countries
                </p>
                <div align="center" className="mt-2">
                <span>
                  <a
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      handleLink("PrivacyPolicy");
                    }}
                    title="Privacy Policy"
                  >
                    Privacy Policy
                  </a>
                </span>                
                <span>
                  <a
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      handleLink("TermsofUse");
                    }}
                    title="Terms of Use"
                  >
                   Terms of Use
                  </a>
                </span>
                <span>
                  <a
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      handleLink("BrowserRequirements");
                    }}
                    title="Browser Requirements"
                  >
                    Browser Requirements
                  </a>
                </span>
                <span>
                  <a
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      handleLink("AccessibilityCompliance");
                    }}
                    title="Accessibility Compliance"
                    className="lst-child"
                  >
                    Accessibility Compliance
                  </a>
                </span>
              </div>
              </div>
            </div>
      </footer>
 
      {/* Global popup: same design as SessionExpireDialog (Material-UI Dialog). */}
      <Dialog
        open={!!showSessionTimeoutPopup}
        onClose={() => setShowSessionTimeoutPopup(false)}
        aria-labelledby="session-timeout-dialog-title"
        aria-describedby="session-timeout-dialog-description"
        className="custom-alert-box-inject"
        disableEscapeKeyDown
      >
        <DialogContent>
          <DialogContentText id="session-timeout-dialog-description">
            {SESSION_EXPIRY_MSG}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            try {
              localStorage.setItem(CMDS_LAST_ACTIVITY_TS, String(Date.now()));
              localStorage.setItem('cmds_session_timeout_warning', 'dismissed');
            } catch (e) {}
            setShowSessionTimeoutPopup(false);
            postToCMDSPortals(GLOBAL_SESSION_TIMEOUT_WARNING_DISMISSED);
          }} color="primary" className="btn btn-success" autoFocus>
            Yes
          </Button>
          <Button onClick={logOut} color="primary">
            No
          </Button>
        </DialogActions>
      </Dialog>
 
</>
   
  );
};
 
export default HomePage;
 
 